"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var dayjs = require("dayjs");
exports.formatDate = function (date, format) {
    var stringFormat = format || "D MMMM YYYY, h:mm:ss";
    return dayjs(date).format(stringFormat);
};
//# sourceMappingURL=format-date.js.map